import React from "react";
import DataDisplayOne from "./helper";
import { DataDisplayTwo } from "./helper";
import axios from "axios";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstList: [],
            secondList: [],
            thirdList: [],
            forthList: [],
            isLoading: false,
            whenNotSearch: true,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }


    setLoaderFunction = () => {

        this.setState({
          loader_status: true,
          try_again_status: false,
          main_content_status: false,
        });
      };
      closeLoaderFuncion = () => {
        this.setState({
          loader_status: false,
          try_again_status: false,
          main_content_status: true,
        });
      };
    
      enableTryAgain = () => {
    
        this.setState({
          loader_status: false,
          try_again_status: true,
          main_content_status: false,
        });
      };


  
   

    componentDidMount() {
        this.fetchDashboardData();
    }


    async fetchDashboardData() {
        try {
          this.setLoaderFunction()
          const token = localStorage.getItem("token");
          const id = this.props.leadId
          const [
            { data: dashboard },
          ] = await Promise.all([
            axios.get("api/admin/dashboard", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } })
          ]);
          this.setState({
            firstList: dashboard.one,
            secondList: dashboard.two,
            thirdList: dashboard.three,
        });
          this.closeLoaderFuncion()
    
        } catch (error) {
          console.error("Error fetching data: ", error);
          this.enableTryAgain()
        }
      }

      tryAgain = () => {
    
        this.fetchDashboardData()
    
      }
    

    render() {
        let token = localStorage.getItem("token");

        if (token == null) {
           // return <Navigate to={"/Login"}/>;
        }


        return (
            <>
                <div>
                {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}

          {this.state.main_content_status && (
                    <div className="flex flex-col flex-1">
                        <main className="flex-1">
                            <div className="py-6">
                                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                    <DataDisplayTwo title={'House Details'} dataOneList={this.state.secondList}/>
                                    {/* <DataDisplayOne title={'Dues Details'} dataOneList={this.state.firstList}/> */}
                                    <DataDisplayOne title={'Overall Profit and Loss'} dataOneList={this.state.thirdList}/>
                                </div>
                            </div>
                        </main>
                    </div>
          )}
                </div>
            </>
        );
    }
}

export default Dashboard;
